module.exports = __webpack_public_path__ + "img/consultation-fee-desktop-fr.237408d1.jpg";